module.exports = __webpack_public_path__ + "img/60_4.798d79ce.png";